// Phase 2 landing — structure/data only. All copy lives in i18n (pages.landing2.*).
export const IMG_TEAM = '/img/cth_hero_team.jpeg';

export const SUITE_META = {
  talentmap:        { name: 'TalentMap',        icon: 'Compass',        color: '#2563EB' },
  talentcheck:      { name: 'TalentCheck',      icon: 'Zap',            color: '#0D9488' },
  talentcompetency: { name: 'TalentCompetency', icon: 'Target',         color: '#6366F1' },
  talenttrain:      { name: 'TalentTrain',      icon: 'GraduationCap',  color: '#D97706' },
  talentstart:      { name: 'TalentStart',      icon: 'Rocket',         color: '#0891B2' },
  talentheart:      { name: 'TalentHeart',      icon: 'HeartHandshake', color: '#E11D48' },
  climara:          { name: 'Climara',          icon: 'CloudSun',       color: '#059669' },
  talentfix:        { name: 'TalentFix',        icon: 'Wrench',         color: '#EA580C' },
  globalethics:     { name: 'Global Ethics',    icon: 'Shield',         color: '#DC2626' },
  workforcerecords: { name: 'Workforce Records', icon: 'FolderArchive', color: '#65A30D' },
  talentperformance: { name: 'TalentPerformance', icon: 'Gauge',        color: '#B45309' },
  succession:       { name: 'Succession',       icon: 'UsersRound',     color: '#0E7490' },
  talentexit:       { name: 'TalentExit',       icon: 'DoorOpen',       color: '#64748B' },
};

// Executive lifecycle groupings — conceptual website categories ONLY (Founder
// release directive §6). They never rename suites.
export const ECO_GROUPS = [
  { key: 'g1', ids: ['talentmap', 'talentcheck', 'talentcompetency'] },
  { key: 'g2', ids: ['talentstart', 'talenttrain'] },
  { key: 'g3', ids: ['talentperformance', 'talentfix'] },
  { key: 'g4', ids: ['climara', 'talentheart'] },
  { key: 'g5', ids: ['globalethics', 'workforcerecords'] },
  { key: 'g6', ids: ['succession', 'talentexit'] },
];

// Challenge inventory: s1–s11 preserved (i18n keys pages.landing.findPath.sX.*),
// TalentIntelligence steps removed (deferred, not market-facing), s12/s13 new
// (Succession continuity, TalentPerformance).
export const CHALLENGES = [
  { id: 's1',  steps: ['talentcheck', 'talentstart', 'talentmap'] },
  { id: 's2',  steps: ['climara', 'talentheart', 'talentfix'] },
  { id: 's3',  steps: ['talentmap', 'talentcompetency', 'talenttrain'] },
  { id: 's4',  steps: ['climara', 'talentmap', 'talenttrain'] },
  { id: 's5',  steps: ['talentcompetency', 'talentmap', 'talenttrain'] },
  { id: 's6',  steps: ['talentfix', 'climara', 'talentheart'] },
  { id: 's7',  steps: ['talentmap', 'talentcompetency', 'talentheart'] },
  { id: 's8',  steps: ['climara', 'talentfix', 'talentmap'] },
  { id: 's9',  steps: ['talentcheck', 'talentmap', 'talentcompetency'] },
  { id: 's10', steps: ['globalethics', 'climara'] },
  { id: 's11', steps: ['workforcerecords', 'talentstart'] },
  { id: 's12', steps: ['succession', 'talenttrain', 'talentexit'] },
  { id: 's13', steps: ['talentperformance', 'talentfix', 'talenttrain'] },
];

// ---- Fictional illustrative chart data (no tenant data) ----
export const RADAR_DIMS = [
  { key: 'd1', score: 78, target: 80 }, { key: 'd2', score: 86, target: 80 },
  { key: 'd3', score: 88, target: 82 }, { key: 'd4', score: 74, target: 78 },
  { key: 'd5', score: 82, target: 80 }, { key: 'd6', score: 90, target: 85 },
  { key: 'd7', score: 84, target: 78 }, { key: 'd8', score: 80, target: 80 },
];

export const COMPETENCIES = [
  { key: 'c1', v: 91 }, { key: 'c2', v: 84 }, { key: 'c3', v: 76 },
  { key: 'c4', v: 69 }, { key: 'c5', v: 82 },
];

export const CLIMATE_AREAS = [
  { key: 'areaHR', v: 86 }, { key: 'areaIT', v: 82 }, { key: 'areaCom', v: 74 },
  { key: 'areaOps', v: 63 }, { key: 'areaSvc', v: 57 }, { key: 'areaLog', v: 47 },
];

export const TRAIN_PROGRESS = [
  { key: 'trainLead', v: 78 }, { key: 'trainComm', v: 64 }, { key: 'trainSafety', v: 91 },
];

export const WR_COMPLIANCE = { pct: 92, complete: 118, due: 9, expired: 4 };

export const MAP_ROLES = [
  { key: 'roleMgmt', v: 87 }, { key: 'roleSup', v: 79 }, { key: 'roleAnalyst', v: 84 },
];

export const SUCC_GAUGES = [
  { key: 'succTech', v: 84 }, { key: 'succEdu', v: 70 },
  { key: 'succExp', v: 78 }, { key: 'succCrit', v: 62 },
];

export const SEMANTIC = {
  green: '#059669', turquoise: '#0D9488', amber: '#D97706',
  orange: '#EA580C', red: '#DC2626', purple: '#7C3AED', blue: '#2563EB',
};

export function climateColor(v) {
  if (v >= 75) return SEMANTIC.green;
  if (v >= 70) return SEMANTIC.turquoise;
  if (v >= 60) return SEMANTIC.amber;
  if (v >= 50) return SEMANTIC.orange;
  return SEMANTIC.red;
}
